module.exports = __webpack_public_path__ + "30de147296c8876f3a53363a157752f9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-right-8.png
// module id = 3050
// module chunks = 0